var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplaneBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2802_5367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81134 16.4184C1.45752 16.0849 1.39478 15.5453 1.66265 15.1396L1.98584 14.6501C2.24565 14.2566 2.74505 14.0981 3.18426 14.2697L5.41332 15.1405L8.62742 12.7075L5.53993 9.06751C5.23238 8.70493 5.22266 8.17592 5.51667 7.80227L6.22721 6.8993C6.49509 6.55886 6.95172 6.42962 7.35829 6.57916L14.0066 9.02454L20.3155 5.83487C21.2891 5.34265 22.4776 5.69674 23.0231 6.64151V6.64151C23.5907 7.62465 23.2538 8.88178 22.2707 9.44939L6.93131 18.3056C5.78397 18.968 4.33798 18.7994 3.37382 17.8908L1.81134 16.4184Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 15,
    height: 1,
    rx: 0.5,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2802_5367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneBlack);
export default __webpack_public_path__ + "static/media/airplane_black.5c8afe1506317c914b449bcc3ce9aeda.svg";
export { ForwardRef as ReactComponent };